import { Component } from '@angular/core';
import { ManikEntityService } from './manik-library/ManikEntityService';
import { Headers, RequestOptions, Response, Http } from '@angular/http';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'EmcityWebSites';
  constructor(private _manikEntityService: ManikEntityService) { }

  ManikCookiePolicy() {

    this._manikEntityService.manikEntityConnect2("website/CookiePolicy")
      .subscribe(data => {
        document.cookie = data.Cookie;
      });
  }
}
